<template>
    <div v-if="lista.length">

        <template v-if="!short">
            <az-sub-title title="Outros Atendimentos" />

            <div class="list-group">
                <button type="button" class="list-group-item list-group-item-action" v-for="(item, idx) in lista" :key="idx" @click="selecionar(item)">
                    <i class="fas fa-star-of-life mr-2"></i>
                    <span class="mr-3">#{{ item.id_atendimento }}</span>
                    <span class="mr-2" v-if="item.dt_inicio.substr(0,10) != dados.dt_inicio.substr(0,10)">{{ $util.getFormatDate(item.dt_inicio) }}</span>
                    <span class="mr-3">{{ item.dt_inicio.substr(11,5) }}</span>
                    <span class="mr-2" v-if="item.procedimento">{{ item.procedimento.search }} </span>
                    <span class="text-muted mr-2" v-if="item.medico">{{ item.medico.st_nome_exibicao }}</span>
                    <span class="badge ml-2" :class="'badge-' + ( item.item_status.cor ? item.item_status.cor : 'secondary' )" v-if="item.item_status">
                        {{ item.item_status.quebra }}
                    </span>
                    <span class="badge badge-light ml-2" v-if="item.unidade_operacao && item.unidade_operacao.st_sigla"
                        :title="item.unidade_operacao.st_nome">
                        {{ item.unidade_operacao.st_sigla }}
                    </span>
                    <span v-if="item.recepcao && item.id_recepcao == id_recepcao">
                        <a href="#" v-if="pode_encaminhar" class="card-link" @click.prevent="$emit('encaminhar', item)">
                            <i class="fas fa-concierge-bell ml-3 mr-2"></i>
                            {{ item.recepcao.search }}
                        </a>
                    </span>
                    <span v-else-if="item.recepcao">
                        <i class="fas fa-concierge-bell ml-3 mr-2"></i>
                        {{ item.recepcao.search }}
                    </span>
                </button>
                
            </div>
        </template>

        <template v-else>
            <i class="fas fa-angle-double-right mr-2"></i>
            <small class="text-muted">{{ lista_texto }}</small>
        </template>

    </div>
</template>

<script>
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    data () { 
        return { 
            id_recepcao: null, 
        };
    },

    props: ['dados', 'short', 'pode_encaminhar'],

    components: { 
        AzSubTitle,
    },

    watch: { 
        dados: { 
            handler: function () {
                let uo = this.$util.unidade_operacao();

                if ( uo && uo.recepcaos.length > 1) { 
                    this.id_recepcao = this.$util.getCookie('id_recepcao');
                } else { 
                    this.id_recepcao = null;
                }
            },
            deep: true,
            immediate: true
        },
    },

    computed: { 
        lista: function () { 
            if ( !this.dados || !this.dados.outras )
                return[];

            return this.dados.outras.filter(item => item.id_marcacao != this.dados.id_marcacao);
        },

        lista_texto: function () { 
            return this.lista.map(item => item.procedimento ? item.procedimento.search : '?').join(', ');
        }

    },

    methods: { 
        selecionar (item) { 
            this.$emit('reabrir', item);
        }
    }
}
</script>